import { Directive } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import * as _ from 'lodash';

@Directive()
export abstract class EaScpiTableFormBuilder extends PrFormAbstract {
  options: any = {};

  generate(entity: any, options?) {
    this.options = [...entity];
    let scpis: UntypedFormGroup[] = [];
    if (entity)
      for (let scpi of entity)
        scpis.push(this.formBuilder.group(this.createModel(scpi)));

    let group = this.formBuilder.group({
      repartitionType: 'PERCENT',
      scpis: this.formBuilder.array(scpis, Validators.nullValidator),
    });

    this.form = group;

    return group;
  }

  public createModel(scpi) {
    const total = _.sumBy(
      [...this.options],
      product => product?.parameters?.scpiInvestmentPrice,
    );

    const percentage = scpi?.parameters?.scpiInvestmentPrice
      ? (scpi?.parameters?.scpiInvestmentPrice / total) * 100
      : null;
    const roundedPercentage: any = percentage
      ? ((percentage * 100) / 100).toFixed(3)
      : null;
    const mostRecentPrice = scpi?.priceHistory?.length
      ? scpi?.priceHistory?.reduce((prev, current) => {
          return new Date(prev.date) > new Date(current.date) ? prev : current;
        })
      : null;

    let model = {
      productId: [scpi ? scpi.productId || scpi?.id : null],
      productName: [scpi ? scpi?.productName || scpi?.name : null],
      repartition: [
        scpi && scpi?.parameters?.scpiInvestmentPrice
          ? roundedPercentage / 100
          : null,
      ],
      parameters: this.formBuilder.group({
        srri: [scpi?.parameters?.srri || null],
        scpiPartPrice: [
          scpi?.parameters?.scpiPartPrice || mostRecentPrice?.value || null,
        ],
        dismembermentDistributionKey: [
          scpi?.parameters?.dismembermentDistributionKey || null,
        ],
        scpiNbPart: [
          scpi?.parameters?.scpiNbPart
            ? Number((scpi?.parameters?.scpiNbPart).toFixed(2))
            : null,
        ],
        scpiInvestmentPrice: [scpi?.parameters?.scpiInvestmentPrice || null],
      }),
    };

    return model;
  }

  extract() {
    const scpis = _.cloneDeep(this.form.value?.scpis);

    const scpiProduct = scpis.map(scpi => {
      return {
        ...scpi,
        parameters: {
          ...scpi?.parameters,
          scpiInvestmentPrice:
            scpi?.parameters?.scpiNbPart *
            scpi?.parameters?.scpiPartPrice *
            (scpi?.parameters?.dismembermentDistributionKey || 1),
        },
      };
    });
    return { products: scpiProduct };
  }
}
